'use client'
import { coinBalanceQueryOptions } from '@/apis/query/profile'
import { useUserStore } from '@/store/useUserStore'
import { useQuery } from '@tanstack/react-query'

export const useCoinBalance = () => {
  const isLogined = useUserStore(state => state.isLogined)
  const userId = useUserStore(state => state.userId)
  const enabled = !!isLogined && userId != null
  const query = useQuery({
    ...coinBalanceQueryOptions(userId ?? 0),
    enabled,
  })
  return {
    coin: enabled ? (query.data?.coin ?? 0) : 0,
    starCoin: enabled ? (query.data?.starCoin ?? 0) : 0,
  }
}
